import moment from 'moment'

const formattingFunctions = {
  currency: amount => {
    amount = new Intl.NumberFormat(window.i18n.locale, {
      style: 'currency',
      currency: window.i18n.currency,
    }).format(amount)

    return amount
  },

  deal_price_per_person: (amount, _dunno, deal) => {
    const dealPrice = amount.DisplayIncludingTax ? amount.IncludingTax : amount.ExcludingTax
    amount = new Intl.NumberFormat(window.i18n.locale, {
      style: 'currency',
      currency: window.i18n.currency,
    }).format(dealPrice)

    const starSymbol = deal.PriceIsStartingPrice ? '*' : ''
    return `${amount}${starSymbol}`
  },

  boolean: value => {
    return value
      ? '<svg class="icon icon-input-checkbox-icon icon-input-checkbox-icon--single"><use xlink:href="#icon-input-checkbox-icon"></use></svg>'
      : ''
  },

  booleanText: value => {
    return value ? 'Yes' : 'No'
  },

  booleanPaidText: (value, type, row) => {
    if (!value && row.isInvoice) {
      return 'Invoice'
    }
    return value ? 'Yes' : 'No'
  },

  booleanActive: value => {
    return value ? 'Active' : 'Inactive'
  },

  datetime: date => {
    const mDate = moment(date)
    if (mDate.isValid()) {
      return mDate.toDate().toLocaleTimeString(window.i18n.locale, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
      })
    }
    return '-'
  },

  date: date => {
    const mDate = moment(date)
    if (mDate.isValid()) {
      return mDate.format('L')
    }
    return '-'
  },

  time: date => {
    const mDate = moment(date)
    if (mDate.isValid()) {
      return mDate.toDate().toLocaleTimeString(window.i18n.locale, {
        hour: 'numeric',
        minute: 'numeric',
      })
    }
    return '-'
  },

  emphasize: value => {
    return '<span class="table__cell--emphasize">' + value + '</span>'
  },

  booking_checked: date => {
    if (date) {
      return '<svg class="icon icon-input-checkbox-icon icon-input-checkbox-icon--single"><use xlink:href="#icon-input-checkbox-icon"></use></svg>'
    } else {
      return ''
    }
  },

  booking_unchecked: date => {
    if (date) {
      return ''
    } else {
      return 'unchecked'
    }
  },

  booking_amount: (amount, dunno, booking) => {
    if (booking.CurrentBillingMethod !== 'None') {
      if (booking.AmountOpen === 0) {
        return (
          '<span class="table__cell--success">' +
          formattingFunctions.currency(booking.AmountTotal) +
          '</span> <span class="table__cell-meta table__cell-meta--success">(Invoice)</span>'
        )
      } else {
        return (
          formattingFunctions.currency(booking.AmountTotal) +
          ' <span class="table__cell-meta table__cell-meta--warning">(Invoice)</span>'
        )
      }
    }
    if (booking.AmountOpen === 0) {
      return (
        '<span class="table__cell--success">' +
        formattingFunctions.currency(booking.AmountTotal) +
        '</span>'
      )
    } else {
      return (
        '<span class="table__cell-meta table__cell-meta--warning">' +
        formattingFunctions.currency(booking.AmountTotal) +
        '</span>'
      )
    }
  },

  price_type: key => {
    return key.replace(/([A-Z])/g, ' $1').replace(/^./, function(str) {
      return str.toUpperCase()
    })
  },

  actions: (key, type, row) => {
    let actions = []
    if (row.edit_url) {
      actions.push(
        '<a href="' +
          row.edit_url +
          '" class="table__action">' +
          '<svg class="icon icon-input-edit-icon"><use xlink:href="#icon-input-edit-icon"></use></svg>' +
          '</a>',
      )
    }
    if (row.delete_url) {
      actions.push(
        '<button type="button" class="table__action" data-toggle="modal" data-target="#briq-modal" data-url="' +
          row.delete_url +
          '">' +
          '<svg class="icon icon-input-trash-icon"><use xlink:href="#icon-input-trash-icon"></use></svg>' +
          '</button>',
      )
    }

    return '<div class="table__actions">' + actions.join('') + '</div>'
  },

  remark: (remark, type, row) => {
    let extraClass = ''
    if (remark !== null) {
      extraClass = 'icon-notes--true'
    }
    return (
      '<svg class="icon icon-notes ' +
      extraClass +
      '"><use xlink:href="#icon-notes"></use></svg>' +
      '<div class="button-table-collapse">' +
      '<svg class="icon icon-input-arrow-down-icon"><use xlink:href="#icon-input-arrow-down-icon"></use></svg>' +
      '</div>'
    )
  },

  internalRemark: (remark, type, row) => {
    let extraClass = ''
    if (remark !== null) {
      extraClass = 'icon-notes--true'
    }
    return (
      '<svg class="icon icon-notes ' +
      extraClass +
      '"><use xlink:href="#icon-notes"></use></svg>' +
      '<div class="button-table-collapse">' +
      '<svg class="icon icon-input-arrow-down-icon"><use xlink:href="#icon-input-arrow-down-icon"></use></svg>' +
      '</div>'
    )
  },

  payment_amount: amount => {
    if (amount) {
      if (amount < 0) {
        return `${formattingFunctions.currency(Math.abs(amount))} -`
      } else {
        return formattingFunctions.currency(amount)
      }
    } else {
      return '-'
    }
  },

  payment_status: (status, type, payment) => {
    const mDate = moment(payment.StatusDatetimeLocal)
    if (!mDate.isValid()) {
      return status
    }
    const localDateTime = mDate.toDate().toLocaleTimeString(window.i18n.locale, {
      year: 'numeric',
      month: 'numeric',
      day: 'numeric',
      hour: 'numeric',
      minute: 'numeric',
    })
    return `${status} ${localDateTime}`
  },

  payment_description: (description, type, payment) =>
    `${description ? `${description}` : ''}${
      payment.VoucherCode ? ` - ${payment.VoucherCode}` : ''
    }`,
}

export default formattingFunctions
